<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img :src="require('../assets/logo.png')" contain height="50" />
        <p></p>
        <h3 style="color:#962283;" class="display-0 font-weight-bold mb-3">
          Connected People
        </h3>
      </v-col>
    </v-row>
    <v-card class="mx-auto" elevation-24 max-width="800">
      <v-card-actions>
        <v-btn :loading="loading" color="oug" text to="/">
          <v-icon>mdi-arrow-left-bold</v-icon>
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="oug" dark @click="addPerson">
            Add
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" :disabled="!havePeople" color="oug" text to="/step3">
          Next
          <v-icon>mdi-arrow-right-bold</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>

      <v-list dense>
        <template v-for="item in people">
          <v-list-item
            :key="item.person"
            :disabled="loading"
          >
            <v-list-item-content>
              <v-list-item-title
                style="color: #962283; font-size: 16px;"
                v-text="item.person"
              ></v-list-item-title>
              <v-list-item-subtitle v-text="item.email"></v-list-item-subtitle>
              <v-list-item-subtitle v-text="item.phone"></v-list-item-subtitle>
              <v-list-item-subtitle 
                style="color:blue; font-size: 14px;"
                v-text="item.ticket"
              ></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-col cols="8">
                <v-icon color="oug" @click="editPerson(item)"
                  >mdi-pencil</v-icon
                >
                <v-icon color="error" @click="deletePerson(item)"
                  >mdi-delete</v-icon
                >
                </v-col
              >
              <v-col cols="1">
              </v-col>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn :loading="loading" color="oug" text to="/">
          <v-icon>mdi-arrow-left-bold</v-icon>
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="oug" dark @click="addPerson">
            Add
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" :disabled="!havePeople" color="oug" text to="/step3">
          Next
          <v-icon>mdi-arrow-right-bold</v-icon>
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-container>
</template>

<script>
import db from "../data/Database";

export default {
  name: "ViewPeople",
  components: {},
  data() {
    return {
      people: [],
      loading: false,
      currentState: [],
      selectedPerson: {},
    };
  },
  created() {
    this.currentState = db.currentState.get(1, (result) =>
      this.loadState(result)
    );
  },
  methods: {
    loadState(result) {
      this.loading = true
      this.currentState = result;
      db.people.toArray((result) => this.loadPeople(result));
    },
    loadPeople(result) {
      this.people = [];
      let icon = "mdi-account";
      for (let index = 0; index < result.length; index++) {
        this.people.push({
          person: result[index].person,
          ticket: result[index].ticket,
          contact_id: result[index].contact_id,
          phone: result[index].phone,
          email: result[index].email,
          icon: icon,
          id: result[index].id,
        });
      }
      this.loading = false
    },
    addPerson() {
      db.currentState.update(1, { selectedPerson: 0 });
      this.$router.push("/Person/step2");
    },
    editPerson(item) {
      db.currentState.update(1, { selectedPerson: item.id });
      this.$router.push("/Person/step2");
    },
    deletePerson(item) {
      confirm("Are you sure you want to delete " + item.person) &&
        db.people.delete(item.id);
      this.loadState(this.currentState);
    },
  },
  computed: {
    havePeople () {
      return (this.people.length > 0)
    }
  },
  watch: {},
};
</script>

<style lang="scss" scoped></style>
